import UmbracoBase from './UmbracoBase';

export default class LastVisitedSalons extends UmbracoBase {
	constructor(args) {
		// Inheriting form UmbracoBase
		super(args);

		this.componentName = 'last-visited-salons';
		this.link = args.link || [];
		this.title = args.title;
		this.subTitle = args.subTitle;
		this.contentBackgroundColor = args.contentBackgroundColor;
		this.numberOfSalonsDisplayed = args.numberOfSalonsDisplayed;

		this.textColor = args.textColor;
		// override text color
		if (this.overrideTextColor) {
			this.textColor.color = this.overrideTextColor;
		} else if (this.textColor.color) {
			this.textColor.color = '#' + this.textColor.color;
		} else {
			this.textColor.color = 'black';
		}

		this.backgroundColor = args.backgroundColor;
		this.overrideBackgroundColor = args.overrideBackgroundColor;

		this.contentBackgroundColor = args.contentBackgroundColor;
		this.overrideContentBackgroundColor = args.overrideContentBackgroundColor;
		if (this.overrideContentBackgroundColor) {
			this.contentBackgroundColor.color = this.overrideContentBackgroundColor.replace('#', '');
		} else if (this.contentBackgroundColor) {
			this.contentBackgroundColor.color = '#' + this.contentBackgroundColor.color;
		} else {
			this.contentBackgroundColor.color = 'none';
		}
	}
}
